import { useAuth } from "../lib/auth.js";

/**
 * Day 2 endpoint: proves a signed-in user reaches a protected page.
 * Day 3 fills this with the upload dropzone and the document list.
 */
export function Documents() {
  const { state, logout } = useAuth();
  const email = state.status === "authenticated" ? state.user.email : "";

  return (
    <div className="page">
      <header className="topbar">
        <span className="brand">DocMind</span>
        <div className="topbar-right">
          <span className="muted">{email}</span>
          <button type="button" className="ghost" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </header>

      <main>
        <h1>Your documents</h1>
        <div className="card empty">
          <p>No documents yet.</p>
          <p className="muted">
            Uploading arrives on Day 3 — this page exists today to prove the
            route guard and session actually work.
          </p>
        </div>
      </main>
    </div>
  );
}
